import { render, staticRenderFns } from "./BinDetailsOverview.vue?vue&type=template&id=bf57f9dc"
import script from "./BinDetailsOverview.vue?vue&type=script&lang=js"
export * from "./BinDetailsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports